<template>
  <div>
    <CModal
      title="Historial de importaciones"
      color="info"
      :show.sync="modalShow"
      class="basic-modal-color"
      size="xl"
    >
      <ImportHistoryTable
        :rows="rows"
        @view-detail="openDetail"
        @download-source="downloadSource"
        @undo-import="openUndo"
      />

      <template #footer>
        <CButton color="secondary" @click="close">Cerrar</CButton>
      </template>
    </CModal>

    <ImportHistoryDetailModal
      :show.sync="showDetail"
      :rows="detailRows"
      :summary="selectedHistory || {}"
      :filter-action="detailFilterAction"
      @change-filter="onDetailFilterChange"
    />

    <UndoImportModal :show.sync="showUndo" @confirm="confirmUndo" />
  </div>
</template>

<script>
import ws from '@/services/events_guests'
import store from '@/store'
import ImportHistoryTable from './ImportHistoryTable.vue'
import ImportHistoryDetailModal from './ImportHistoryDetailModal.vue'
import UndoImportModal from './UndoImportModal.vue'

export default {
  name: 'ImportHistoryModal',
  components: {
    ImportHistoryTable,
    ImportHistoryDetailModal,
    UndoImportModal,
  },
  data() {
    return {
      show: false,
      eventId: 0,
      rows: [],
      selectedHistory: null,
      showDetail: false,
      detailRows: [],
      detailFilterAction: 'all',
      showUndo: false,
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.show
      },
      set(value) {
        this.show = value
      }
    }
  },
  methods: {
    async showHistoryModal(eventId) {
      this.eventId = eventId
      this.show = true
      this.selectedHistory = null
      this.detailRows = []
      this.detailFilterAction = 'all'
      await this.loadHistory()
    },
    close() {
      this.show = false
    },
    async loadHistory() {
      this.loading()
      try {
        const response = await ws.getImportHistory({ event_id: this.eventId })
        if (response.type === 'success') {
          this.rows = response.data || []
        } else {
          this.showToast(response.type, response.message)
        }
      } catch (e) {
        this.showToast('error', 'No se pudo cargar el historial de importaciones.')
      }
      this.loaded()
    },
    async openDetail(item) {
      this.selectedHistory = item
      this.showDetail = true
      await this.loadDetail()
    },
    async downloadSource(item) {
      if (!item || !item.id) {
        return
      }

      this.loading()
      try {
        const response = await ws.downloadImportHistorySource({
          event_id: this.eventId,
          history_id: item.id,
        })

        if (response.type === 'success' && response.data && response.data.url) {
          window.open(response.data.url, '_blank')
        } else {
          this.showToast(response.type || 'error', response.message || 'No se pudo obtener el archivo de respaldo.')
        }
      } catch (e) {
        this.showToast('error', 'No se pudo descargar el archivo de importacion.')
      } finally {
        this.loaded()
      }
    },
    async loadDetail() {
      if (!this.selectedHistory) {
        return
      }

      this.loading()
      try {
        const response = await ws.getImportHistoryDetail({
          event_id: this.eventId,
          history_id: this.selectedHistory.id,
          action: this.detailFilterAction,
        })

        if (response.type === 'success') {
          this.detailRows = response.data && response.data.changes ? response.data.changes : []
        } else {
          this.showToast(response.type, response.message)
        }
      } catch (e) {
        this.showToast('error', 'No se pudo cargar el detalle del historial.')
      }
      this.loaded()
    },
    async onDetailFilterChange(action) {
      this.detailFilterAction = action || 'all'
      await this.loadDetail()
    },
    openUndo(item) {
      this.selectedHistory = item
      this.showUndo = true
    },
    async confirmUndo() {
      if (!this.selectedHistory) {
        return
      }

      this.loading()
      try {
        const response = await ws.undoImport({
          event_id: this.eventId,
          history_id: this.selectedHistory.id,
        })

        this.showUndo = false

        if (response.type === 'success') {
          this.showToast('success', response.message || 'Reversión completada.')
          await this.loadHistory()
          this.$emit('refresh')
          return
        }

        this.showToast(response.type, response.message)
      } catch (e) {
        this.showToast('error', 'No se pudo completar la reversión.')
      }
      this.loaded()
    },
    showToast(type, message) {
      store.commit('toast', { color: type, message })
    },
    loading() {
      store.commit('loading')
    },
    loaded() {
      store.commit('loaded')
    }
  }
}
</script>
